import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var freeShippingSchema = {
    free_shipping_for_logged_users: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
        }),
        elementType: 'inputSwitch',
        label: 'Активиране на безплатна доставка',
        value: '',
        validation: {
            required: false
        },
        valid: false,
        touched: false,
        errorMsg: '',
    }),
};
export default freeShippingSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/freeShippingSchema.ts
// module id = 349
// module chunks = 0